module.exports = __webpack_public_path__ + "static/radu-amarie-ee64e3a4b9df90b59570827960aa5bf1.jpg";